import React, { useState, useEffect } from 'react';
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
  updateDoc,
  doc,
  Timestamp,
} from 'firebase/firestore';
import appFirebase from '../Firebase/Firebase';
import './AsignarCoins.css';
import Navbar from '../Components/NavBarAirbnbStyle';
import NavbarMobileVersion from '../Components/NavBar/NavBarMobileVersion';

const db = getFirestore(appFirebase);

const AsignarCoins = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [newCoins, setNewCoins] = useState(0);
  const [expirationDate, setExpirationDate] = useState('');
  const [status, setStatus] = useState('');

  useEffect(() => {
    const fetchUsers = async () => {
      if (searchTerm.trim() === '') {
        setUsers([]);
        return;
      }
      const q = query(
        collection(db, 'usuarios'),
        where('name', '>=', searchTerm),
        where('name', '<=', searchTerm + '\uf8ff')
      );
      const querySnapshot = await getDocs(q);
      const filteredUsers = [];
      querySnapshot.forEach((docSnap) => {
        const data = docSnap.data();
        const email = data.email || '';
        const name = data.name || '';
        if (
          email.toLowerCase().includes(searchTerm.toLowerCase()) ||
          name.toLowerCase().includes(searchTerm.toLowerCase())
        ) {
          filteredUsers.push({ ...data, id: docSnap.id });
        }
      });

      setUsers(filteredUsers);
    };
    fetchUsers();
  }, [searchTerm]);

  const handleAssignCoins = async () => {
    if (!selectedUser || !expirationDate) {
      setStatus('Selecciona un usuario y una fecha de expiración válida');
      return;
    }

    try {
      const userRef = doc(db, 'usuarios', selectedUser.id);
      const expiration = new Date(expirationDate);
      const now = new Date();

      await updateDoc(userRef, {
        coins: Number(newCoins) + selectedUser.coins,
        coinsComprados: Number(newCoins) + selectedUser.coinsComprados,
        coinRenovation: now,
        coinExpiration: expiration,
      });

      setStatus('Coins asignados correctamente');
    } catch (error) {
      console.error(error);
      setStatus('Error al asignar coins');
    }
  };
  const [isDarkMode, setIsDarkMode] = useState(() => {
      try {
        // Intentamos leer valor guardado en localStorage
        const saved = localStorage.getItem('darkMode');
        if (saved !== null) {
          const parsed = JSON.parse(saved);
          if (typeof parsed === 'boolean') return parsed; // Solo si es booleano válido
        }
      } catch (error) {
        // Si JSON.parse falla o localStorage no está disponible, ignoramos el error
        console.warn('Error leyendo localStorage darkMode:', error);
      }
  
      // Detectar modo oscuro sistema solo si está disponible window.matchMedia
      const prefersDark = typeof window !== 'undefined' && window.matchMedia
        ? window.matchMedia('(prefers-color-scheme: dark)').matches
        : false;
  
      // Detectar hora nocturna (7pm a 6am)
      const hour = new Date().getHours();
      const isNight = hour >= 19 || hour < 6;
  
      // Retorna true o false seguro
      return prefersDark || isNight;
    });
  
    // Cargar el tema al inicio (localStorage, sistema u hora)
    useEffect(() => {
      const savedTheme = localStorage.getItem('darkMode');
      if (savedTheme !== null) {
        setIsDarkMode(JSON.parse(savedTheme));
      } else {
        // Detecta modo oscuro sistema
        const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
  
        // Detecta modo oscuro por hora (7pm - 6am)
        const hour = new Date().getHours();
        const isNight = hour >= 19 || hour < 6;
  
        setIsDarkMode(prefersDark || isNight);
      }
    }, []);
  
    // Guardar la preferencia y aplicar clase al body
    useEffect(() => {
      localStorage.setItem('darkMode', JSON.stringify(isDarkMode));
      document.body.classList.toggle('dark-mode', isDarkMode);
    }, [isDarkMode]);
  
    // Función para cambiar el modo
    const toggleDarkMode = () => setIsDarkMode(!isDarkMode);
  

  return (
    <>
      <Navbar isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
      <NavbarMobileVersion isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
      <div className="asignar-coins-container">
      <h2 className='asignar-coins-title'>Asignar Coins a un Usuario</h2>
      <input
        type="text"
        placeholder="Buscar por nombre o correo"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      {users.length > 0 && (
        <ul className="user-list">
          {users.map((user) => (
            <li key={user.id} onClick={() => setSelectedUser(user)}>
              {user.name} - {user.email} (Coins: {user.coins})
            </li>
          ))}
        </ul>
      )}

      {selectedUser && (
        <div className="assign-section">
          <p>
            Usuario seleccionado: <strong>{selectedUser.name}</strong> ({selectedUser.email})
          </p>
          <input
            type="number"
            placeholder="Nuevo valor de coins"
            value={newCoins}
            onChange={(e) => setNewCoins(e.target.value)}
          />
          <label>Fecha de expiración:</label>
          <input
            type="date"
            value={expirationDate}
            onChange={(e) => setExpirationDate(e.target.value)}
          />
          <button onClick={handleAssignCoins}>Asignar Coins</button>
          {status && <p className="status-msg">{status}</p>}
        </div>
      )}
    </div></>
  );
};

export default AsignarCoins;
